<template>
  <div>
    <ErrorNotice v-if='action.hasError()' :error='action.getError()' />

    <FormView :controller='formController' :fields='collection.getCreateFormFields()' :showCancel='false' :buttonLabel='`Create ${collection.getSingleLabel()}`' class='mt-4' />

    <ProgressAlert :isPresenting='action.isLoading()'>
      <template #title>
        Creating {{ collection.getSingleLabel() }}
      </template>
    </ProgressAlert>
  </div>
</template>

<script setup>

import { usePayloadAction } from '@/kernel/api';
import { getCollection } from '@/kernel/collections';

import { useFormController } from '@/kernel/controllers/form-controller';
import { useToastManager } from '@/kernel/managers/toast-manager';

import { replaceRoute } from '@/router/index.js';

import ErrorNotice from '@/components/notices/error-notice.vue';
import ProgressAlert from '@/components/alerts/progress-alert.vue';
import FormView from '@/components/views/form-view.vue';
import SuccessToast from '@/components/toasts/success-toast.vue';

const props = defineProps({
  collection: String
});

const collection = getCollection(props.collection);

const toastManager = useToastManager();
const toastController = toastManager.registerToast('collection-create-form', SuccessToast);

const action = usePayloadAction('POST', collection.getApiIndexEndpoint());

const formController = useFormController({
  formContexts: collection.getCreateFormContexts(),
  onSubmit: async () => {
    if (!formController.hasDelta()) {
      return;
    }

    const delta = formController.getDelta();

    try {
      const data = await action.doAction({body: delta});

      toastController.present({data: {title: `${collection.getSingleLabel()} created successfully.`}});

      replaceRoute({
        path: collection.getRedirectAfterCreate(data.doc)
      });
    } catch(e) {
      window.scroll({
        top: 0,
        behaviour: 'smooth'
      });
    }
  }
});


</script>
